import { Formik } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SuccessNotifcation from "../../notifications/success";

export default function RegisterForm() {
	const navigate = useNavigate();
	const [showNotifcation, setShowNotifcation] = useState(false);
	const [registerType, setRegisterType] = useState("doctor");
	const [loading, setloading] = useState(false);
	const [error, setError] = useState("");

	const formHandle = (values, url) => {
		setloading(true);
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				firstname: values.firstname,
				lastname: values.lastname,
				email: values.email,
				password: values.password,
				password_confirm: values.confirmPassword,
				phone_number: values.phone,
				city: values.city,
				country: values.country,
				dob: values.dob,
				gender: values.gender,
			}),
		};
		fetch(`${url}`, requestOptions)
			.then((response) => {
				setloading(false);
				if (response.status == 200) {
					return response.json();
				} else {
					throw "Error";
				}
			})
			.then((data) => {
				console.log("data", data);
				setShowNotifcation(true);
				setTimeout(() => {
					setShowNotifcation(false);
					navigate("/login");
				}, 2000);
			})
			.catch((err) => {
				setError(err);
				console.log("err", err);
			});
	};

	return (
		<>
			<SuccessNotifcation
				show={showNotifcation}
				setShowNotifcation={() => setShowNotifcation(false)}
			/>
			<div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
				<div className="sm:mx-auto sm:w-full sm:max-w-md">
					<div className="flex justify-around">
						<span className="isolate inline-flex rounded-md shadow-sm">
							<button
								type="button"
								onClick={() => setRegisterType("doctor")}
								className={`${
									registerType == "doctor" && "bg-indigo-500 text-white"
								} relative inline-flex items-center rounded-l-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 focus:z-10`}>
								Register as Doctor
							</button>
							<button
								type="button"
								onClick={() => setRegisterType("patient")}
								className={`${
									registerType == "patient" && "bg-indigo-500 text-white"
								} relative -ml-px inline-flex items-center rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 focus:z-10`}>
								Register as Patient
							</button>
						</span>
					</div>
				</div>
				<div className="sm:mx-auto sm:w-full sm:max-w-md">
					<Formik
						initialValues={{
							firstname: "",
							lastname: "",
							email: "",
							password: "",
							confirmPassword: "",
							phone: "",
							city: "",
							country: "",
						}}
						validate={(values) => {
							const errors = {};
							if (!values.email || !values.password) {
								errors.email = "* Required";
								errors.password = "* Required";
							} else if (values.password !== values.confirmPassword) {
								errors.confirmPassword = "Password not matching";
							} else if (
								!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
							) {
								errors.email = "Invalid email address";
							}
							return errors;
						}}
						onSubmit={async (
							values,
							{ setErrors, setStatus, setSubmitting }
						) => {
							if (registerType === "doctor") {
								formHandle(
									values,
									"https://testapi.secondop.in/backend/api/v1/auth/register"
								);
							} else {
								formHandle(
									values,
									"https://testapi.secondop.in/backend/api/v1/auth/register/patient"
								);
							}
						}}>
						{({
							values,
							errors,
							touched,
							handleChange,
							handleBlur,
							handleSubmit,
							isSubmitting,
							/* and other goodies */
						}) => (
							<div className="mt-10 sm:mx-auto sm:w-full sm:max-w-md">
								<form onSubmit={handleSubmit} className="space-y-6">
									{error && (
										<span className="text-rose-700 text-sm">{error}</span>
									)}
									<div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
										<div className="sm:col-span-3">
											<label
												htmlFor="firstname"
												className="block text-sm font-medium leading-6 text-gray-900">
												First name
											</label>
											<div className="mt-2">
												<input
													type="text"
													name="firstname"
													id="firstname"
													autoComplete="given-name"
													onChange={handleChange}
													onBlur={handleBlur}
													value={values.firstname}
													className="px-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
												/>
											</div>
											<span className="text-rose-800 text-xs">
												{errors.firstname &&
													touched.firstname &&
													errors.firstname}
											</span>
										</div>

										<div className="sm:col-span-3">
											<label
												htmlFor="lastname"
												className="block text-sm font-medium leading-6 text-gray-900">
												Last name
											</label>
											<div className="mt-2">
												<input
													type="text"
													name="lastname"
													id="lastname"
													autoComplete="family-name"
													onChange={handleChange}
													onBlur={handleBlur}
													value={values.lastname}
													className="px-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
												/>
											</div>
											<span className="text-rose-800 text-xs">
												{errors.lastname && touched.lastname && errors.lastname}
											</span>
										</div>
									</div>

									<div>
										<label
											htmlFor="email"
											className="block text-sm font-medium leading-6 text-gray-900">
											Email address
										</label>
										<input
											type="email"
											name="email"
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.email}
											className="px-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
										/>
										<span className="text-rose-800 text-xs">
											{errors.email && touched.email && errors.email}
										</span>
									</div>

									<div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
										<div className="sm:col-span-3">
											<label
												htmlFor="password"
												className="block text-sm font-medium leading-6 text-gray-900">
												Password
											</label>
											<div className="mt-2">
												<input
													type="password"
													name="password"
													onChange={handleChange}
													onBlur={handleBlur}
													value={values.password}
													className="px-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
												/>
												<span className="text-rose-800 text-xs">
													{errors.password &&
														touched.password &&
														errors.password}
												</span>
											</div>
										</div>

										<div className="sm:col-span-3">
											<label
												htmlFor="confirmPassword"
												className="block text-sm font-medium leading-6 text-gray-900">
												Confirm Password
											</label>
											<div className="mt-2">
												<input
													type="password"
													name="confirmPassword"
													onChange={handleChange}
													onBlur={handleBlur}
													value={values.confirmPassword}
													className="px-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
												/>
												<span className="text-rose-800 text-xs">
													{errors.confirmPassword &&
														touched.confirmPassword &&
														errors.confirmPassword}
												</span>
											</div>
										</div>
									</div>

									<div>
										<label
											htmlFor="phone"
											className="block text-sm font-medium leading-6 text-gray-900">
											Phone
										</label>
										<input
											type="phone"
											name="phone"
											onChange={handleChange}
											onBlur={handleBlur}
											value={values.phone}
											className="px-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
										/>
										<span className="text-rose-800 text-xs">
											{errors.phone && touched.phone && errors.phone}
										</span>
									</div>

									{registerType === "patient" && (
										<>
											<div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
												<div className="sm:col-span-3">
													<label
														htmlFor="city"
														className=" block text-sm font-medium leading-6 text-gray-900">
														Gender
													</label>
													<div className="mt-2">
														<select
															value={values.gender}
															onChange={handleChange}
															onBlur={handleBlur}
															id="gender"
															name="gender"
															autoComplete="gender"
															className="bg-white px-2 block w-full rounded-md border-0 py-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6">
															<option selected>Select</option>
															<option>Male</option>
															<option>Female</option>
														</select>
													</div>
													<span className="text-rose-800 text-xs">
														{errors.gender && touched.gender && errors.gender}
													</span>
												</div>

												<div className="sm:col-span-3">
													<label
														htmlFor="country"
														className="block text-sm font-medium leading-6 text-gray-900">
														Date of Birth
													</label>
													<div className="mt-2">
														<input
															type="date"
															name="dob"
															onChange={handleChange}
															onBlur={handleBlur}
															value={values.dob}
															className="px-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
														/>
													</div>
													<span className="text-rose-800 text-xs">
														{errors.dob && touched.dob && errors.dob}
													</span>
												</div>
											</div>
										</>
									)}

									<div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
										<div className="sm:col-span-3">
											<label
												htmlFor="city"
												className=" block text-sm font-medium leading-6 text-gray-900">
												City
											</label>
											<div className="mt-2">
												<input
													type="text"
													name="city"
													id="city"
													onChange={handleChange}
													onBlur={handleBlur}
													value={values.city}
													className="px-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
												/>
											</div>
											<span className="text-rose-800 text-xs">
												{errors.city && touched.city && errors.city}
											</span>
										</div>

										<div className="sm:col-span-3">
											<label
												htmlFor="country"
												className="block text-sm font-medium leading-6 text-gray-900">
												Country
											</label>
											<div className="mt-2">
												<input
													type="text"
													name="country"
													onChange={handleChange}
													onBlur={handleBlur}
													value={values.country}
													className="px-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
												/>
											</div>
											<span className="text-rose-800 text-xs">
												{errors.country && touched.country && errors.country}
											</span>
										</div>
									</div>

									<div>
										{loading ? (
											<button
												disabled
												type="button"
												className="w-full justify-center py-1.5 px-5 text-sm font-medium text-gray-400 bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 inline-flex items-center">
												<svg
													aria-hidden="true"
													role="status"
													class="inline w-4 h-4 me-3 text-gray-200 animate-spin dark:text-gray-600"
													viewBox="0 0 100 101"
													fill="none"
													xmlns="http://www.w3.org/2000/svg">
													<path
														d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
														fill="currentColor"
													/>
													<path
														d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
														fill="#1C64F2"
													/>
												</svg>
												Loading...
											</button>
										) : (
											<button
												type="submit"
												className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
												disabled={isSubmitting}>
												{loading ? "loading.." : "Submit"}
											</button>
										)}
									</div>
								</form>
							</div>
						)}
					</Formik>
				</div>
			</div>
		</>
	);
}
